import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-991b5f48")

_pushScopeId("data-v-991b5f48")
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "main-reverse-page-title" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "promo-search-panel mt-16" }
const _hoisted_11 = { class: "d-lg-flex row align-items-center" }
const _hoisted_12 = {
  key: 0,
  class: "promo-actions d-flex order-lg-1 col-2 mb-lg-0 justify-content-center justify-content-lg-end"
}
const _hoisted_13 = { class: "d-flex col" }
const _hoisted_14 = { class: "d-flex" }
const _hoisted_15 = { class: "promo-total" }
const _hoisted_16 = { class: "mt-16" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "promo-search-panel mt-16" }
const _hoisted_19 = { class: "d-lg-flex row align-items-center" }
const _hoisted_20 = {
  key: 0,
  class: "promo-actions d-flex order-lg-1 col-2 mb-lg-0 justify-content-center justify-content-lg-end"
}
const _hoisted_21 = { class: "agencies-search col-lg-3" }
const _hoisted_22 = { class: "d-flex col" }
const _hoisted_23 = { class: "search-button-wrapper d-flex" }
const _hoisted_24 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-search fs-20" }, null, -1)
const _hoisted_25 = { class: "d-flex" }
const _hoisted_26 = { class: "show-all-clear-filter align-items-lg-center" }
const _hoisted_27 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-filter fs-24 pl7" }, null, -1)
const _hoisted_28 = {
  key: 0,
  class: "promo-filter-circle"
}
const _hoisted_29 = { class: "promo-total" }
const _hoisted_30 = { class: "mt-16" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_PromoCategories = _resolveComponent("PromoCategories")
  const _component_PromoProducts = _resolveComponent("PromoProducts")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('navbar.promoManagement')), 1),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("button", {
          class: ["promo-cat-button", { active: _ctx.currentPromotedType == _ctx.PromotedType.UpperBanner }],
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addRouteParams(_ctx.PromotedType.UpperBanner)))
        }, _toDisplayString(_ctx.$t('button.promoTopBanner')), 3)
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("button", {
          class: ["promo-cat-button", { active: _ctx.currentPromotedType == _ctx.PromotedType.Carousel }],
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addRouteParams(_ctx.PromotedType.Carousel)))
        }, _toDisplayString(_ctx.$t('button.promoCarousel')), 3)
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("button", {
          class: ["promo-cat-button", { active: _ctx.currentPromotedType == _ctx.PromotedType.MiddleBanner }],
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addRouteParams(_ctx.PromotedType.MiddleBanner)))
        }, _toDisplayString(_ctx.$t('button.promoMiddleBanner')), 3)
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode("button", {
          class: ["promo-cat-button", { active: _ctx.currentPromotedType == _ctx.PromotedType.Category }],
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addRouteParams(_ctx.PromotedType.Category)))
        }, _toDisplayString(_ctx.$t('button.promoCategory')), 3)
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode("button", {
          class: ["promo-cat-button", { active: _ctx.currentPromotedType == _ctx.PromotedType.BottomBanner }],
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addRouteParams(_ctx.PromotedType.BottomBanner)))
        }, _toDisplayString(_ctx.$t('button.promoBottomBanner')), 3)
      ])
    ]),
    (_ctx.currentPromotedType == _ctx.PromotedType.Category)
      ? (_openBlock(), _createBlock("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, [
            _createVNode("div", _hoisted_11, [
              (_ctx.promo.promotedCategories && _ctx.promo.promotedCategories.length < 8)
                ? (_openBlock(), _createBlock("div", _hoisted_12, [
                    _createVNode(_component_router_link, {
                      to: { name: 'editPromoCategory', params: { type: _ctx.PromotedType[_ctx.currentPromotedType] } },
                      class: "promo-circle-btn btn-green flex-center"
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('promo.newItem')), 1)
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_13, [
                _createVNode("div", _hoisted_14, [
                  _createVNode("div", _hoisted_15, [
                    _createVNode("div", null, _toDisplayString(_ctx.$t('agencies.totalFiltered')) + ":", 1),
                    _createVNode("div", null, _toDisplayString(_ctx.totalFiltered) + " (" + _toDisplayString(_ctx.$t('agencies.ofAgencies')) + " " + _toDisplayString(_ctx.total) + ")", 1)
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_16, [
            _createVNode(_component_PromoCategories, {
              items: _ctx.promo?.promotedCategories,
              onOnDelete: _ctx.deletePromoCategory,
              onOnOrder: _ctx.orderPromoCategories,
              filter: _ctx.filter,
              onOnSort: _ctx.sortBy
            }, null, 8, ["items", "onOnDelete", "onOnOrder", "filter", "onOnSort"])
          ])
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_17, [
          _createVNode("div", _hoisted_18, [
            _createVNode("div", _hoisted_19, [
              (
                (_ctx.promo?.promotedProducts.map(x => x.type === _ctx.PromotedType.UpperBanner) && _ctx.promo?.promotedProducts.map(x => x.type === _ctx.PromotedType.UpperBanner).length == 0 && _ctx.currentPromotedType === _ctx.PromotedType.UpperBanner) ||
                _ctx.currentPromotedType !== _ctx.PromotedType.UpperBanner)
                ? (_openBlock(), _createBlock("div", _hoisted_20, [
                    _createVNode(_component_router_link, {
                      to: { name: 'editPromoProduct', params: { type: _ctx.PromotedType[_ctx.currentPromotedType] } },
                      class: "promo-circle-btn btn-green flex-center"
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('promo.newItem')), 1)
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_21, [
                _withDirectives(_createVNode("input", {
                  class: "bookit-input w100",
                  type: "text",
                  placeholder: _ctx.$t('promo.searchPlaceholder'),
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.filter.keyword = $event)),
                  onKeyup: _cache[7] || (_cache[7] = _withKeys(
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)), ["enter"]))
                }, null, 40, ["placeholder"]), [
                  [
                    _vModelText,
                    _ctx.filter.keyword,
                    void 0,
                    { trim: true }
                  ]
                ])
              ]),
              _createVNode("div", _hoisted_22, [
                _createVNode("div", _hoisted_23, [
                  _createVNode("button", {
                    type: "button",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.search()))
                  }, [
                    _hoisted_24
                  ])
                ]),
                _createVNode("div", _hoisted_25, [
                  _createVNode("div", _hoisted_26, [
                    _createVNode("span", {
                      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.showAll && _ctx.showAll(...args)))
                    }, _toDisplayString(_ctx.$t('button.showAll')), 1)
                  ]),
                  _createVNode("div", {
                    class: ["promo-filter", { hasFilter: _ctx.hasFilter }]
                  }, [
                    _createVNode("button", {
                      type: "button",
                      class: "promo-filter-btn-text",
                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.showFilter && _ctx.showFilter(...args)))
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.$t('button.filters')) + " ", 1),
                      _hoisted_27
                    ]),
                    (_ctx.hasFilter)
                      ? (_openBlock(), _createBlock("div", _hoisted_28, "!"))
                      : _createCommentVNode("", true)
                  ], 2),
                  _createVNode("div", _hoisted_29, [
                    _createVNode("div", null, _toDisplayString(_ctx.$t('agencies.totalFiltered')) + ":", 1),
                    _createVNode("div", null, _toDisplayString(_ctx.totalFiltered) + " (" + _toDisplayString(_ctx.$t('agencies.ofAgencies')) + " " + _toDisplayString(_ctx.total) + ")", 1)
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_30, [
            _createVNode(_component_PromoProducts, {
              items: _ctx.promo?.promotedProducts,
              promotedType: _ctx.currentPromotedType,
              filter: _ctx.filter,
              onOnDelete: _ctx.deletePromoProduct,
              onOnSort: _ctx.sortBy,
              onOnOrder: _ctx.orderPromoProducts
            }, null, 8, ["items", "promotedType", "filter", "onOnDelete", "onOnSort", "onOnOrder"])
          ])
        ]))
  ]))
})